// Rockwall County SEO cluster — 13 routable pages (8 English + 5 Spanish), all driven by configs.
import RockwallSEOPage from "@/components/seo/RockwallSEOPage";
import {
  rockwallCountyHubConfig,
  tirzepatideHubConfig,
  semaglutideHubConfig,
  buildCityConfig,
} from "@/data/rockwallSeoConfigs";
import {
  rockwallCountyHubConfigEs,
  buildCityConfigEs,
} from "@/data/rockwallSeoConfigsEs";

export function RockwallCountyHubPage()       { return <RockwallSEOPage config={rockwallCountyHubConfig} />; }
export function RockwallTirzepatidePage()     { return <RockwallSEOPage config={tirzepatideHubConfig} />; }
export function RockwallSemaglutidePage()     { return <RockwallSEOPage config={semaglutideHubConfig} />; }
export function RockwallCityPage()            { return <RockwallSEOPage config={buildCityConfig("rockwall")} />; }
export function RoyseCityPage()               { return <RockwallSEOPage config={buildCityConfig("royse-city")} />; }
export function FateCityPage()                { return <RockwallSEOPage config={buildCityConfig("fate")} />; }
export function HeathCityPage()               { return <RockwallSEOPage config={buildCityConfig("heath")} />; }
export function MclendonChisholmCityPage()    { return <RockwallSEOPage config={buildCityConfig("mclendon-chisholm")} />; }

// ─── Spanish counterparts ───
export function RockwallCountyHubPageEs()     { return <RockwallSEOPage config={rockwallCountyHubConfigEs} />; }
export function RockwallCityPageEs()          { return <RockwallSEOPage config={buildCityConfigEs("rockwall")} />; }
export function RoyseCityPageEs()             { return <RockwallSEOPage config={buildCityConfigEs("royse-city")} />; }
export function FateCityPageEs()              { return <RockwallSEOPage config={buildCityConfigEs("fate")} />; }
export function HeathCityPageEs()             { return <RockwallSEOPage config={buildCityConfigEs("heath")} />; }
